import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { products } from '../data'
import { HomePath } from '../home-path'

export default function OrdersRevised() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
  return (
    <div className="w-full h-fit py-12">
        <div className="mxw">
            <div className="w-full h-fit py-4 text-left">
                <p className="text-3xl font-bold">Your Orders</p>
            </div>
            {products?.slice(8,12)?.map(product => (
                <a href={HomePath + `/product/${product?.id}/details`} target="_blank" rel="noreferrer noopener">
                    <div className="w-full grid grid-cols-2 gap-4 md:gap-8 h-fit md:h-96 py-6 border-t border-gray-100 rounded-2xl px-2 my-2">
                        {/* <div className="bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${product?.img})` }}/> */}
                        <div className="flex items-center justify-center overflow-hidden">
                            <img className="h-full w-full object-cover" src={product?.img} alt="" />
                        </div>
                        <div className="space-y-1 text-gray-700">
                            <h3 className="text-lg md:text-xl capitalize font-bold">{product?.type}</h3>
                            <h3 className="capitalize text-sm md:text-md lg:text-lg">{product?.name}</h3>
                            <p className="capitalize text-sm md:text-md lg:text-lg">Product color</p>
                            <p className="capitalize text-sm md:text-md lg:text-lg">Size 11</p>
                            <p className="capitalize text-sm md:text-md lg:text-lg">Delivery: to be done</p>
                            <div className="w-full flex items-center justify-between">
                                <p className="">Qty: 1</p>
                                <p className="font-bold text-lg md:text-xl">${product?.price}</p>
                            </div>
                        </div>
                    </div>
                </a>
            ))}
        </div>
    </div>
  )
}
